import React, { useEffect, useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = {
  '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 },
};

const PartnerKpis = ({ setPartnerKpi, delay = 0 }) => {
  const [isReady, setIsReady] = useState(false);

  // Stagger loading with delay
  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // Use useQuery for proper caching (replaces useMutation)
  const { data, isLoading, isError, error } = useQuery(
    ['partners-kpi'],
    client.creators.listKPI,
    {
      enabled: isReady,  // Only fetch when delay has passed
      staleTime: 10 * 60 * 1000,  // 10 minutes (matches backend cache)
      cacheTime: 15 * 60 * 1000,  // 15 minutes
      refetchOnWindowFocus: false
    }
  );

  // Update parent component when data changes
  useEffect(() => {
    if (data) {
      const total = Object.values(data).reduce((s, r) => s + r.total_partner, 0);
      setPartnerKpi({ progress: total });
    }
  }, [data, setPartnerKpi]);

  // Memoize sorted rows
  const rows = useMemo(() => {
    if (!data) return [];
    return Object.entries(data).sort(
      (a, b) => new Date(b[0]) - new Date(a[0])
    );
  }, [data]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!data) return <div>Loading...</div>;

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>Creators</TableCell>
              <TableCell>Emails</TableCell>
              <TableCell>Partners Added</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography>No data available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map(([date, d]) => (
                <TableRow key={date}>
                  <TableCell>{date}</TableCell>
                  <TableCell>{d.creators?.join(', ') || 'N/A'}</TableCell>
                  <TableCell>{d.emails?.join(', ') || 'N/A'}</TableCell>
                  <TableCell>{d.total_partner}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PartnerKpis;
